import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Footer/Footer.js'
import WebComponent from '../../WebComponent.js'
import FooterService from './FooterService.js'

export default class Footer extends WebComponent {

  get translationFile() {
    return './views/Footer/i18n.json'
  }

  get css() {
    return css`
      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
      }
      a {
        text-decoration: none;
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
    this.version = ''
  }

  reload() {
    const service = new FooterService()
    Promise.all([
      service.list(), fetch('./version.json').then(r => r.json())
    ])
      .then(([backend, frontend]) => {
        this.version = `- (v${frontend.version}/${backend.version}/${backend.service})`
        this.render()
      }).catch(_ => {
      this.render()
    })
  }

  getTemplate() {
    return html`
      <isceco-footer text="${this.i18n.translate('footer.blv')} ${this.version}">
        <ul>
          <li>
            <a href="${this.i18n.translate('footer.rechtliches.link')}">${this.i18n.translate('footer.rechtliches')}</a>
          </li>
        </ul>
      </isceco-footer>
    `
  }
}

customElements.define('eltra-management-footer', Footer)
